import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {Preferences} from '../model/preferences.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PortfolioPreferences} from '../model/portfolio-preferences.model';

@Injectable()
export class PreferencesService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getUserPreferences(userId: string, withoutDefaults?: boolean): Promise<Preferences> {
        const url = `${this.configService.baseUrl()}preferences`;
        return Preferences.from(await this.httpClient.get<Preferences>(url, {
            params: new HttpParams().set('userId', userId).set('withoutDefaults', withoutDefaults ? withoutDefaults.toString() : 'false')
        }).toPromise());
    }

    public async saveUserPreferences(userId: string, preferences: Preferences, isPreferenceFromPro?: string): Promise<Preferences> {
        let url: string ;
        preferences.userId = userId;
        if(isPreferenceFromPro) {
            url =  `${this.configService.baseUrl()}preferences?isPreferenceFromPro=${isPreferenceFromPro}`
        } else {
            url =  `${this.configService.baseUrl()}preferences`
        }

        return Preferences.from(await this.httpClient.put<Preferences>(url, preferences).toPromise());
    }

    public async getPortfolioPreferences(portfolioId: string): Promise<PortfolioPreferences> {
        const url = `${this.configService.baseUrl()}portfolio-preference`;
        const httpParams = new HttpParams().set('portfolioId', portfolioId);

        return await this.httpClient.get<PortfolioPreferences>(url, {params: httpParams}).toPromise();
    }

    public async savePortfolioPreferences(portfolioPreferences: PortfolioPreferences): Promise<void> {
        const url = `${this.configService.baseUrl()}portfolio-preference`;
        await this.httpClient.post(url, portfolioPreferences).toPromise();
    }
}
